import React from "react";
import { TableCell } from "@mui/material";
import TwoWheelerIcon from "@mui/icons-material/TwoWheeler";

// Columna condicional "Informes Operador": solo se renderiza cuando la
// solicitud no está rechazada/anulada y el domicilio está activo y aprobado.
export default function CeldaInformeOperador({ data, setIsOpenPdf, setDataInforme }) {
  const debeMostrarse =
    // Ambos activos: ambos estados deben ser 2


    // Solo Domicilio activo
    (
      data.Estado !== 5 && data.Estado !== 4 &&
      data?.Domicilio == 1 &&
      data?.idEstadoVerificacionDomicilio == 2);

  if (!debeMostrarse) return null;

  return (
    <TableCell align="center">
      <button
        onClick={() => {
          setIsOpenPdf(true);
          setDataInforme(data);
        }}
        className="bg-blue-100 text-blue-700 hover:bg-blue-200 hover:text-blue-900 transition-all duration-200 rounded-full p-2"
      >
        <TwoWheelerIcon className="text-blue-700" />
      </button>
    </TableCell>
  );
}
